import React from "react";
import Header from "../../Components/Header/Header";
import BannerGlobal from "../../Components/Banner/BannerGlobal";
import ClientReview from "../../Components/ClientReview/ClientReview";
import TeamComponent from "../../Components/TeamComponent/TeamComponent";
import Mailbox from "../../Components/Footer/Mailbox";
import Footer from "../../Components/Footer/Footer";
import MenuItemDetails from "../../Components/MenuItem/MenuItemDetails";
import BrandComponent from "../../Components/BrandComponent/BrandComponent";

const MenuDetails = () => {
  return (
    <div className="menu2">
      <Header />
      <BannerGlobal />
      <MenuItemDetails/>
      <ClientReview />
      <TeamComponent />
      <BrandComponent/>
      <Mailbox />
      <Footer />
    </div>
  );
};

export default MenuDetails;
